import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useParams, useSearchParams, useLocation } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import SideNavigation from 'app/components/layout/side-navigaion/side-navigation';
import ActivityCardDetails from 'app/components/ui/activity-details-section/activity-details-card/activity-details-card';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import {
  fetchActivities,
  fetchunAuthorosiedActivities,
  fetchActivityDetails,
  fetchActivityDetailsUnauthorized,
  deleteActivityByIds,
} from 'app/shared/reducers/activity-home';
import ActivityDetailsSidePanel from '../activity-details-side-panel/activity-details-side-panel';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import { getAccessToken } from 'app/utils/common-utils/common-utils';
import { Button, MenuItem, Select, Typography, useMediaQuery } from '@mui/material';
import toast from 'react-hot-toast';
import PrimaryHeader from 'app/components/layout/header/primary-header';
import AmyIcon from 'app/components/common/cards/chat-card/amy-icons';
import PaymentResponseModal from 'app/components/common/modals/payment-reponse/payment-response';
import { useItemId } from 'app/utils/hooks/useItemId';
import metaTagUpdateReverse from 'app/components/MetaTagReverse';
import useMetaTagUpdater from 'app/components/metaTagUpdater';
import axios from 'axios';
import 'app/components/layout/common-layout.scss';

const drawerWidth = 315;
const drawerWidthSm = 248;
interface Props {
  window?: () => Window;
}
export const ActivitySection = () => {
  let token;
  const { id } = useParams();
  const location = useLocation(); // To get the current URL
  const activityId = useItemId();
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  console.log('activityId', activityId);
  useEffect(() => {
    return () => {
      localStorage.removeItem('dynamicDescription');
      localStorage.removeItem('dynamicTitle');
      localStorage.removeItem('dynamicImage');
      localStorage.removeItem('dynamicUrl');
    };
  }, []);

  const [category, setCategory] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [activity, setActivity] = useState<any>({});
  const [activityNotFound, setActivityNotFound] = useState(false);
  const [loading, setLoading] = useState(true);
  const [bookmarkSuccess, setBookmarkSuccess] = useState(false);
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const consentPending = useAppSelector(state => state.authentication.consentPending);
  const isAuthenticatedAndConsented = isAuthenticated && !consentPending;
  const eventType = useAppSelector(state => state.homeActivity.eventType);
  const leaveActivityType = useAppSelector(state => state.leaveActivityReducer.success);
  const reportActivity = useAppSelector(state => state.reportActivityReducer.success);
  const [volunteerButtonClick, setvolunteerButtonClick] = useState(false);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [likeSuccess, setLikemarkSuccess] = useState(false);
  const [blockedParticipant, setblockedParticipant] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [isResponseSuccess, setIsResponseSuccess] = useState(false);
  const [toggleValue, setToggleValue] = useState(false);
  const [toggleMapValue, setToggleMapValue] = useState(false);
  const [toggleFeatureValue, setToggleFeatureValue] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState<string>('');

  const makeModeratorSuccess = useAppSelector(state => state.activitParticipants.success);
  const isSmallScreen = useMediaQuery('(max-width:767px)');
  const breakPoint = useMediaQuery('(max-width:988px)');
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isDarkMode = theme.palette.mode === 'dark';

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const status = searchParams.get('status');
    if (status) {
      setShowResponseModal(true);
      setIsResponseSuccess(status === 'success');
    }
  }, [searchParams]);

  const handleResponseClose = () => {
    setShowResponseModal(false);
    setSearchParams({}, { replace: true });
  };

  const authTokenFromStorage = (async () => {
    try {
      const authToken = await getAccessToken();
      if (authToken) {
        return authToken;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  })();

  (async () => {
    token = await authTokenFromStorage;
  })();
  const [hasNavigated, setHasNavigated] = useState(false);
  const isNavigating = useRef(false);

  useEffect(() => {
    // Check only once on mount - prevents location changes from triggering re-checks
    const canGoBack = window.history.length > 1 &&
      (window.history.state?.idx > 0 || document.referrer !== '');
    setHasNavigated(canGoBack);
  }, []); // Empty array - runs only once, prevents view count inflation

  // Function to call view count API
  const fetchViewCount = async (activityId: string) => {
    const myDetailsAccount = localStorage.getItem('MyDetailsAccount');
    const userId = myDetailsAccount ? JSON.parse(myDetailsAccount)?.id : null;

    try {
      if (isAuthenticated && userId) {
        await axios.post(`api/activities/${activityId}/add-view?userId=${userId}`);
      } else {
        await axios.post(`api/unauthorized/activities/${activityId}/add-view`);
      }
    } catch (error) {
      // Silently handle errors - don't disrupt user experience
      console.error('Error updating view count:', error);
    }
  };

  // Track the last location key to ensure view count increments on each page visit
  const lastLocationKey = useRef<string | null>(null);

  // Separate useEffect for view count - runs when user enters the details page
  useEffect(() => {
    if (isNavigating.current) return; // Skip if navigating away

    const currentLocationKey = location.key || location.pathname;
    if (activityId && lastLocationKey.current !== currentLocationKey) {
      fetchViewCount(activityId);
      lastLocationKey.current = currentLocationKey;
    }
  }, [activityId, location.key, location.pathname, isAuthenticated]);

  useEffect(() => {
    if (activityId) {
      const fetchActivitiesInfo = async () => {
        setLoading(true);
        try {
          let response;

          if (isAuthenticatedAndConsented && localStorage.getItem('MyDetailsAccount')) {
            response = await dispatch(fetchActivityDetails(activityId));
          } else {
            response = await dispatch(fetchActivityDetailsUnauthorized(activityId));
          }

          if (response.meta.requestStatus === 'fulfilled') {
            useMetaTagUpdater(response.payload);
            setActivity(response.payload);
            setIsSubmitClicked(false);
            setvolunteerButtonClick(false);
            setActivityNotFound(false);
          } else {
            console.log('Error response:', response.error);
            setActivityNotFound(true);
          }
        } catch (error) {
          console.error('An error occurred while fetching activity details:', error);
          setActivityNotFound(true);
          toast.error('Something went wrong while fetching activity details', { id: 'activity-fetch-error' });
        } finally {
          setLoading(false);
        }
      };

      fetchActivitiesInfo();
    }
  }, [
    activityId,
    isAuthenticated,
    volunteerButtonClick,
    isSubmitClicked,
    leaveActivityType,
    reportActivity,
    makeModeratorSuccess,
    blockedParticipant,
  ]);

  const handleGoBack = () => {
    metaTagUpdateReverse();
    isNavigating.current = true; // Block view count
    navigate(-1);
  };

  const handleSubCategoryClick = (category: string, subCategory: string) => {
    setCategory(category);
    setSubCategory(subCategory);
  };

  const handleAccordionClick = (categoryId: any, currentState: any) => {
    setCategory(categoryId);
  };

  const handleBookmarkSuccess = () => {
    setBookmarkSuccess(s => !s);
  };

  const handleLikeSuccess = () => {
    setLikemarkSuccess(s => !s);
  };

  const handleVolunteerButtonClick = value => {
    setvolunteerButtonClick(value);
  };

  const handleIsSubmitClicked = value => {
    setIsSubmitClicked(value);
  };

  const handleParticipantBlocked = value => {
    setblockedParticipant(value);
  };

  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  }));

  const handleButtonMapClicked = () => {
    const newToggleMapValue = !toggleMapValue;
    if (toggleValue || toggleFeatureValue) {
      setToggleValue(false);
      setToggleFeatureValue(false);
    }
    setToggleMapValue(newToggleMapValue);
  };

  const drawer = (
    <Box
      sx={{
        border: 'none',
        height: '100vh',
        overflowY: 'scroll',
        overflowX: 'hidden',
        background:
          theme.palette.mode === 'dark'
            ? theme.palette.background.default
            : 'transparent linear-gradient(133deg, #F7F5EF 35%, #F2F2FA 58%, #EFEFF5 100%) 0% 0% no-repeat padding-box',

        maxWidth: { sm: drawerWidthSm, lg: drawerWidth, md: drawerWidthSm },
        backdropFilter: 'blur(10px)',

        '&::-webkit-scrollbar': {
          display: 'none',
        },
        '&::-webkit-scrollbar-thumb': { backgroundColor: 'secondary.contrastText', height: '10px' },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
      }}
    >
      {consentPending && <Box sx={{ height: '44px', flexShrink: 0 }} />}
      <DrawerHeader sx={{ justifyContent: 'center', height: '79px', border: 'none' }}>
        <Box style={{ paddingLeft: '0px', paddingRight: '50px' }}>
          <Link to={'/'}>
            <AmyIcon sx={{ width: '159px', height: '100px' }} />
          </Link>
        </Box>
      </DrawerHeader>

      <SideNavigation
        category={category}
        subCategory={subCategory}
        onSubCategoryClick={handleSubCategoryClick}
        onhandleAccordionClick={handleAccordionClick}
        onButtonClicked={() => { }}
        onMapClicked={handleButtonMapClicked}
        toggleMapValue={toggleMapValue}
        setToggleMapValue={setToggleMapValue}
        onFeatureClicked={() => { }}
      />
      <Divider />
    </Box>
  );

  const container = window !== undefined ? () => window.document.body : undefined;

  const styles = {
    ...(isSmallScreen || breakPoint
      ? {
        border: 'none',
      }
      : {
        height: '85vh',
        overflow: 'unset',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        '&::-webkit-scrollbar-thumb': { backgroundColor: 'secondary.contrastText', height: '10px' },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
      }),
  };
  const handleUpdateData = (data: any) => {
    setActivity(data);
  };
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          background: isDarkMode ? '#1F1F26' : 'transparent linear-gradient(118deg, #F7F5EF 0%, #F2F2FA 49%, #EFEFF5 100%) 0% 0% no-repeat',
          p: 0,
          border: 'none',
          backdropFilter: 'blur(10px)',
          height: '100vh',
          overflow: 'hidden',
        }}
      >
        <CssBaseline />
        <AppBar
          elevation={0}
          position="fixed"
          sx={{
            top: consentPending ? '44px' : 0,
            width: { sm: `calc(100% - ${drawerWidthSm}px)`, md: `calc(100% - ${drawerWidthSm}px)`, lg: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidthSm}px`, md: `${drawerWidthSm}px`, lg: `${drawerWidth}px` },
            background: isDarkMode ? '#2C2C38' : 'transparent',
          }}
        >
          <Toolbar
            className="amy-top-nav"
            sx={{
              backgroundColor: ' transparent linear-gradient(118deg, #F7F5EF 0%, #F2F2FA 49%, #EFEFF5 100%) 0% 0% no-repeat',
              background: isDarkMode ? '#1F1F26' : '',
              border: 'none',
              backdropFilter: 'blur(10px)',
            }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' }, top: '10px' }}
            >
              <MenuIcon />
            </IconButton>
            <PrimaryHeader searchKeyword={searchKeyword} setSearchKeyword={setSearchKeyword} />
          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{
            width: { sm: drawerWidthSm, md: drawerWidthSm, lg: drawerWidth },
            flexShrink: { sm: 0 },
            minHeight: '100vh',
            border: 'none',
            background: isDarkMode
              ? '#1F1F26'
              : 'transparent linear-gradient(118deg, #F7F5EF 0%, #F2F2FA 49%, #EFEFF5 100%) 0% 0% no-repeat',
          }}
          aria-label="activity-detail"
        >
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidthSm },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: { sm: drawerWidthSm, md: drawerWidthSm, lg: drawerWidth } },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          className="inside-bg"
          component="main"
          sx={{
            flexGrow: 1,
            maxWidth: '100%',

            p: 3,
            width: {
              sm: `calc(100% - ${drawerWidthSm} px)`,
              md: `calc(100% - ${drawerWidthSm} px)`,
              lg: `calc(100% - ${drawerWidth} px)`,
              background: isDarkMode
                ? '#1F1F26'
                : ' transparent linear-gradient(172deg, #F7F5EF 0%, #F2F2FA 49%, #EFEFF5 100%) 0% 0% no-repeat padding-box',
              border: 'none',
              backdropFilter: 'blur(10px)',
            },
          }}
        >
          <div className="row" style={{ padding: 1, marginTop: consentPending ? '106px' : '50px' }}>
            <ArrowCircleLeftIcon
              onClick={() => handleGoBack()}
              sx={{
                cursor: 'pointer',
                color: isDarkMode ? '#FFCE00' : '#775fff',
                borderRadius: '50%',
                fontSize: '50px',
                marginLeft: '10px',
                opacity: hasNavigated ? 1 : 0.5,
                pointerEvents: hasNavigated ? 'auto' : 'none',
              }}
            />
          </div>

          <Box
            className="p-3"
            sx={{
              background: isDarkMode ? '#1F1F26' : '',
              height: '77vh',
              overflowY: 'scroll',
              overflowX: 'hidden',

              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            }}
          >
            <div className="row screen-space">
              <div className={`col-md-${breakPoint ? '12' : '8'}`} style={{ paddingLeft: '0px !important' }}>
                <Box sx={styles}>
                  {activityNotFound && (
                    <Box
                      display="flex"
                      height="60vh"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        padding: '24px',
                      }}
                    >
                      <Box
                        component="img"
                        sx={{
                          borderRadius: '8px',
                          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                          maxHeight: { xs: 300, md: 200 },
                          maxWidth: { xs: 400, md: 300 },
                        }}
                        alt="No activity found illustration"
                        src="content/images/empty.svg"
                      />
                      <Typography
                        fontSize="24px"
                        mt={3}
                        fontWeight="bold"
                        sx={{
                          color: isDarkMode ? '#FFCE00' : '#4A4A4A',
                          textAlign: 'center',
                        }}
                      >
                        Activity Not Found
                      </Typography>
                      <Typography
                        fontSize="16px"
                        mt={1}
                        color={isDarkMode ? '#BFBFBF' : '#757575'}
                        sx={{
                          textAlign: 'center',
                        }}
                      >
                        Sorry, the activity you're looking for doesn't exist or has been removed.
                      </Typography>
                      <Button
                        variant="contained"
                        sx={{
                          mt: 4,
                          background: isDarkMode ? '#FFCE00' : '#674BFF',
                          color: '#fff',
                          borderRadius: '20px',
                          padding: '10px 24px',
                          textTransform: 'none',
                          fontWeight: '600',
                          '&:hover': {
                            background: isDarkMode ? '#FFC800' : '#563ECC',
                          },
                        }}
                        onClick={() => window.location.replace('/')}
                      >
                        Back to Home
                      </Button>
                    </Box>
                  )}
                  <ActivityCardDetails
                    activityResponse={activity}
                    onBookmarkSuccess={handleBookmarkSuccess}
                    onLikeSuccess={handleLikeSuccess}
                    handleDeleteClick={async id => {
                      try {
                        const response = await dispatch(deleteActivityByIds({ activityIds: [id], organizationId: 0, message: '' }));
                        if (typeof response.payload === 'string') {
                          try {
                            if (authTokenFromStorage) {
                              dispatch(fetchActivities({ eventType: eventType }));
                              navigate('/');
                            } else {
                              dispatch(fetchunAuthorosiedActivities({ eventType: eventType }));
                            }
                          } catch (error) {
                            console.log(error);
                          }
                        }
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    onParticipantBlocked={handleParticipantBlocked}
                    setNewData={handleUpdateData}
                  />
                </Box>
                <PaymentResponseModal handleClose={handleResponseClose} open={showResponseModal} isSuccess={isResponseSuccess} />
              </div>
              <div className={`col-md-${breakPoint ? '12' : '4'}`}>
                <div
                  style={{
                    background: isDarkMode ? '#2C2C38' : '#FFFFFF',
                    borderRadius: '15px',
                    marginTop: isSmallScreen || breakPoint ? '2%' : '0',
                  }}
                >
                  <ActivityDetailsSidePanel
                    activityResponse={activity}
                    volunteerButtonClick={volunteerButtonClick}
                    isSubmitClicked={isSubmitClicked}
                    onVolunteerButtonClick={handleVolunteerButtonClick}
                    onIsSubmitClicked={handleIsSubmitClicked}
                  />
                </div>
              </div>
            </div>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default ActivitySection;

